import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { FormattedMessage } from '@flipster/i18n';
import ShieldStarIcon from '@flipster/react/icon/generated/ShieldStarIcon';
import { Styles, css } from '@flipster/styled-system/css';
import { center, grid, hstack, stack } from '@flipster/styled-system/patterns';

import { copyTradingBunja } from '../../../shared/copy-trading/state';
import CopyTradingImage from '../../assets/copy-trading.webp';
import { MyCopyTradeBalance } from './my-copy-trade-balance';

export const titleKey = 'Copy.r251107.Copy_master_traders_trade_smarter';
export const Header = ({ css: cssProps }: { css?: Styles }) => {
  const { myStatusAtom } = useBunja(copyTradingBunja);
  const myStatus = useAtomValue(myStatusAtom);
  return (
    <div
      className={css(
        grid.raw({
          tabletDown: {
            gridTemplateAreas: `
              "image"
              "header"
            `,
          },
          tablet: {
            gridTemplateAreas: `
              "header header image"
            `,
            gridTemplateColumns: 'repeat(3, 1fr)',
            minH: 398,
          },
          gap: 16,
        }),
        (!myStatus || (myStatus.numOngoingCopies == 0 && myStatus.numStoppedCopies == 0)) && {
          tablet: {
            // I don't want to do this but design requirement wants to remove layout gap on no status
            mb: -96,
          },
        },
        cssProps,
      )}
    >
      <div className={stack({ gap: 16, gridArea: 'header', tablet: { pt: 80 } })}>
        <div className={stack({ gap: 8 })}>
          {myStatus?.isMaster && (
            <div className={hstack({ color: 'content.accent.VIP', textStyle: 'Title/XS' })}>
              <ShieldStarIcon size={20} className={css({ m: 6 })} />
              <p>
                <FormattedMessage id='Copy.r251107.You_are_a_master_trader' />
              </p>
            </div>
          )}
          <h2 className={css({ textStyle: 'Display/XL', color: 'content.default.level-5', whiteSpace: 'pre-wrap' })}>
            <FormattedMessage id={titleKey} />
          </h2>
        </div>
        <MyCopyTradeBalance />
      </div>
      <div
        className={center({
          gridArea: 'image',
          tabletDown: { textAlign: 'center' },
          tablet: { minW: 0, textAlign: 'right' },
          maxW: 408,

          h: '100%',
        })}
      >
        <img
          src={CopyTradingImage.src}
          className={css({ w: '100%', maxW: 280 })}
          alt='Background image for Copy Trading'
        />
      </div>
    </div>
  );
};
